import { Message } from '@/types/discover';

export const CHATBOT_LANDING_QUESTIONS = [
  '가장 많이 판매된 상품 알려줘',
  '배송상태별 주문 확인해 줘',
  '마켓별 주문된 상품의 이름과 주문 건수 알려줘',
  '클레임 건수 알려줘',
  '주문 확인해야할 건 알려줘',
  '배송처리해야 할 건 알려줘',
];

export const CHATBOT_INITIAL_MESSAGE: Message = {
  id: 0,
  text: '원하는 판매 데이터를 셀러박스 AI에게 물어보세요.\n9시부터 18시까지 실시간 데이터를 제공해요.',
  sender: 'bot',
};

export const SESSION_RESET_ALERT: Message = {
  id: 999,
  text: '이전 대화 내역을 초기화했어요.\n새로운 대화를 시작해 주세요.',
  sender: 'alert',
};
